export default "__VITE_ASSET__CtRckox3__"